import { useState } from "react";
import { Button, Flex, Radio, useMantineTheme } from "@mantine/core";
import {
  PaymentFrequency,
  useUpdateAgreementMutation,
  useUpdateSubscriptionMutation,
} from "src/generated/graphql";
import { useModals } from "@mantine/modals";

interface INextDraftProps {
  subscriptionId: string;
  frequency: PaymentFrequency;
  onRefetch: () => void;
}

const Frequency = ({
  subscriptionId,
  frequency,
  onRefetch,
}: INextDraftProps) => {
  const modals = useModals();
  const theme = useMantineTheme();
  const [value, setValue] = useState<PaymentFrequency>(frequency);

  const [updateSubscriptionPaymentFrequency, { loading }] =
    useUpdateSubscriptionMutation({
      onCompleted: () => {
        onRefetch();
        modals.closeAll();
      },
    });

  const handleUpdateAgreement = () => {
    updateSubscriptionPaymentFrequency({
      variables: {
        id: subscriptionId,
        data: {
          paymentFrequency: value,
        },
      },
    });
  };
  return (
    <>
      <Radio.Group
        value={value}
        name="Frequency"
        description="Select Payment Frequency"
        withAsterisk
        styles={{
          root: {
            "&:focus-within": {
              label: {
                transform: "translateY(0px)",
              },
            },
          },
        }}
      >
        <Flex direction={"column"} mt="xs">
          {Object.entries(PaymentFrequency)?.map(([key, value]) => {
            return (
              <Radio
                mx={10}
                my={5}
                width={"100%"}
                key={key}
                value={value}
                label={value}
                sx={{
                  ".mantine-Radio-label": {
                    color: theme.colors.secondaryTextColor[6],
                  },
                }}
                onClick={() => setValue(value)}
              />
            );
          })}
        </Flex>
      </Radio.Group>

      <Button
        size={"xs"}
        mt={20}
        disabled={!value || loading}
        onClick={handleUpdateAgreement}
      >
        Save
      </Button>
    </>
  );
};

export default Frequency;
